import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useEffect } from 'react';

import { useExperimentTreatmentWithoutReporting, useReportExperimentTreatmentCallback } from '../experiments';

import { useIsVivaEngageRebranding } from './useIsVivaEngageRebranding';

type UseReportWebRebrandLeftNavTreatment = () => void;
export const useReportWebRebrandLeftNavTreatment: UseReportWebRebrandLeftNavTreatment = () => {
  const isVivaEngageRebranding = useIsVivaEngageRebranding();
  const rebrandLeftNavTreatment = useExperimentTreatmentWithoutReporting(Experiment.WebRebrandedLeftNav);

  const reportRebrandLeftNavTreatmentCallback = useReportExperimentTreatmentCallback(
    Experiment.WebRebrandedLeftNav,
    rebrandLeftNavTreatment
  );

  useEffect(() => {
    if (isVivaEngageRebranding) {
      reportRebrandLeftNavTreatmentCallback();
    }
  }, [isVivaEngageRebranding, reportRebrandLeftNavTreatmentCallback]);
};
